
import _ from 'lodash';
import Uploader from '@/components/Uploader/index.vue';

var isOverLimit = function isOverLimit(fileSize, maxSize) {
  return fileSize > maxSize;
};

export default {
  name: 'SingleFileUploader',

  componentName: 'SingleFileUploader',

  components: {
    Uploader: Uploader
  },

  props: {
    config: {
      type: Object,
      required: true
    },
    formValue: {
      type: Object,
      required: true
    }
  },

  data: function data() {
    return {
      loading: false,
      fileList: [],
      multiple: false // 当前组件只支持上传单个
    };
  },


  watch: {
    'config.params.fileList': {
      handler: function handler(val) {
        this.fileList = val;
      },

      deep: true
    }
  },

  mounted: function mounted() {
    if (_.get(this.config, 'params.fileList')) {
      this.fileList = _.get(this.config, 'params.fileList');
    }
  },


  methods: {
    uploadError: function uploadError(msg) {
      this.$message({
        message: msg || '上传失败，请重新尝试',
        type: 'warning'
      });
    },
    handleBeforeUpload: function handleBeforeUpload(file) {
      // 清空参数，避免上传中就点击提交，
      // eslint-disable-next-line vue/no-mutating-props
      this.formValue[this.config.prop] = '';
      if (this.config.params && this.config.params.maxSize && isOverLimit(file.size, this.config.params.maxSize * 1024 * 1024)) {
        this.uploadError('\u6587\u4EF6\u5927\u5C0F\u4E0D\u80FD\u8D85\u8FC7 ' + this.config.params.maxSize + 'mb');
        return false;
      }
      return true;
    },
    handleUploadChange: function handleUploadChange(file, fileList) {
      // 如果存在maxSize参数
      if (fileList.length > 1) {
        fileList.splice(0, 1);
      }
    },
    handleUploadError: function handleUploadError(erro, file, fileList) {
      fileList = [];
    },
    handleUploadSuccess: function handleUploadSuccess(response, file, fileList) {
      var _this = this;

      if (response.code === 0) {
        fileList[0].name = response.data.origin_name;
        fileList[0].url = response.data.file_path;
        this.fileList = fileList;
        // eslint-disable-next-line vue/no-mutating-props
        this.formValue[this.config.prop] = response.data.file_path;
      } else {
        this.$message({
          message: response.msg ? response.msg : '上传失败，请重新尝试',
          type: 'warning'
        });
        setTimeout(function () {
          _this.fileList = [];
          // eslint-disable-next-line vue/no-mutating-props
          _this.formValue[_this.config.prop] = '';
          _this.$refs.uploader.clearFiles();
        });
      }
      if (this.config.params.handleSuccess && typeof this.config.params.handleSuccess === 'function') {
        this.config.params.handleSuccess(response, file, fileList);
      }
    },
    handleClickPreview: function handleClickPreview(file) {
      if (file.response && file.response.data && file.response.data.url) {
        window.open(file.response.data.url);
      } else {
        window.open(file.url);
      }
    }
  }
};